import React from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Menu } from "@/components/Menu";
import { Highlights } from "@/components/Highlights";
import { Booking } from "@/components/Booking";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-cream min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Menu />
        <Highlights />
        <Booking />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
